import React from 'react';

const DeviceInfoTable = ({ deviceData }) => {
    return (
        <div className="device-info-table">
            {deviceData.map((item, index) => (
                <div key={index} className="expanded-detail-item">
                    <strong>{item.label}:</strong>
                    <span>{item.value}</span>
                </div>
            ))}
        </div>
    );
};

export default DeviceInfoTable;
